import { createFileRoute } from '@tanstack/react-router'
import { WebsiteEditor } from '@/features/wedding-web/pages/website-editor'
export const Route = createFileRoute('/_auth/w/$workspaceSlug/website')({ component: Page })
function Page() {
  return <WebsiteEditor slug={Route.useParams().workspaceSlug} day={false} />
}
